import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

const FALLBACK = {
  name: "Yeni Mercan Restoran",
  phone: "+90 555 961 2464",
  whatsapp: "905559612464",
  address: "Buca, İzmir",
  hours: "7 gün 24 saat açık",
  instagram: "yenimercanrestoranbuca",
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return <SiteContext.Provider value={{ settings, loaded, reload }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
